import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

const List = styled('div')`
  li {
    list-style-type: none;

    margin-bottom: 20px;
    width: 220px;
  }
  li ul {
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 0;
  }
  li ul li {
    margin-bottom: 5px;
    margin-top: 5px;
  }
`;

const Categories = () => {
  const { t } = useTranslation();

  const getCategories = () => {
    return (
      <ul
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 50,
        }}
      >
        <li>
          {t('catTitle.Véhicules')}
          <ul>
            <li>
              <Link href={'/annonces/voitures'}>{t('category.Voitures')}</Link>
            </li>
            <li>
              <Link href={'/annonces/motos'}>{t('category.Motos')}</Link>
            </li>
            <li>
              <Link href={'/annonces/equipement-auto'}>
                {t('category.Équipement Auto')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/equipement-moto'}>
                {t('category.Équipement Moto')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/bateaux'}>{t('category.Bateaux')}</Link>
            </li>
            <li>
              <Link href={'/annonces/nautisme'}>{t('category.Nautisme')}</Link>
            </li>
            <li>
              <Link href={'/annonces/equipement-nautisme'}>
                {t('category.Équipement Nautisme')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/utilitaires'}>
                {t('category.Utilitaires')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Immobilier')}
          <ul>
            <li>
              <Link href={'/annonces/ventes-immobilieres'}>
                {t('category.Ventes Immobilières')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/locations'}>
                {t('category.Locations')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/colocations'}>
                {t('category.Colocations')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Multimédia')}
          <ul>
            <li>
              <Link href={'/annonces/informatique'}>
                {t('category.Informatique')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/telephonie'}>
                {t('category.Téléphonie')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/console-jeux-videos'}>
                {t('category.Console & Jeux Vidéos')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/image-et-son'}>
                {t('category.Image et son')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Maison')}
          <ul>
            <li>
              <Link href={'/annonces/mobilier'}>{t('category.Mobilier')}</Link>
            </li>
            <li>
              <Link href={'/annonces/electromenager'}>
                {t('category.Électroménager')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/decoration'}>
                {t('category.Décoration')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/bricolage'}>
                {t('category.Bricolage')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/jardinage'}>
                {t('category.Jardinage')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Camping')}
          <ul>
            <li>
              <Link href={'/annonces/tentes-abris'}>
                {t('category.Tentes & Abris')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/accessoires-de-camping'}>
                {t('category.Accessoires de camping')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Vêtements & Bijoux')}
          <ul>
            <li>
              <Link href={'/annonces/vetements'}>
                {t('category.Vêtements')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/chaussures'}>
                {t('category.Chaussures')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/vetements-bebe'}>
                {t('category.Vêtements Bébé')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/puericulture'}>
                {t('category.Puériculture')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/accessoires'}>
                {t('category.Accessoires')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/montres-bijoux'}>
                {t('category.Montres & Bijoux')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/vide-grenier'}>
                {t('category.Vide Grenier')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Loisirs')}
          <ul>
            <li>
              <Link href={'/annonces/dvd'}>{t('category.DVD')}</Link>
            </li>
            <li>
              <Link href={'/annonces/cd-musique'}>
                {t('category.CD & Musique')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/livres'}>{t('category.Livres')}</Link>
            </li>
            <li>
              <Link href={'/annonces/animaux'}>{t('category.Animaux')}</Link>
            </li>
            <li>
              <Link href={'/annonces/velos'}>{t('category.Vélos')}</Link>
            </li>
            <li>
              <Link href={'/annonces/sports'}>{t('category.Sports')}</Link>
            </li>
            <li>
              <Link href={'/annonces/instruments-de-musique'}>
                {t('category.Instruments de musique')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/collection'}>
                {t('category.Collection')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/jeux-jouets'}>
                {t('category.Jeux & Jouets')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Services')}
          <ul>
            <li>
              <Link href={'/annonces/prestation-de-services'}>
                {t('category.Prestation de services')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/cours-particuliers'}>
                {t('category.Cours particuliers')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/covoiturage'}>
                {t('category.Covoiturage')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/echanges-troc'}>
                {t('category.Échanges & Troc')}
              </Link>
            </li>
            <li>
              <Link href={'/annonces/perdu-trouve'}>
                {t('category.Perdu / Trouvé')}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.Emploi')}
          <ul>
            <li>
              <Link href={'/annonces/offres-demploi'}>
                {t("category.Offres d'emploi")}
              </Link>
            </li>
          </ul>
        </li>
        <li>
          {t('catTitle.--- Autres ---')}
          <ul>
            <li>
              <Link href={'/annonces/autres'}>{t('category.Autres')}</Link>
            </li>
          </ul>
        </li>
      </ul>
    );
  };

  return (
    <Grid
      style={{
        paddingTop: 35,
        backgroundColor: 'white',
        padding: '40px 12px',
        fontFamily: 'Poppins',
      }}
    >
      <Row>
        <Col style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          <h2>{t('categories.body.title')}</h2>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: '100%' }}>
          <List>{getCategories()}</List>
        </Col>
      </Row>
    </Grid>
  );
};

export default Categories;
